import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { first } from 'rxjs/operators';
import { ReviewService, Review } from '@app/_components/review';
import { AlertService, AuthenticationService, DataCacheService } from '@app/_services';
import { Router } from '@angular/router';
import { SelectItem, LazyLoadEvent, MessageService } from 'primeng/api';
import { Locations, ListingStatus } from '@app/_helpers/constants';
import { DialogService } from 'primeng/dynamicdialog';
import { Reservation } from '@app/_components/reservation';
import { ReservationListComponent } from '../reservation-list/reservation-list.component';
import { ReservationSearchFormComponent } from './reservation-search-form/reservation-search-form.component';

@Component({
    selector: 'app-reservation-search',
    templateUrl: './reservation-search.component.html',
    styleUrls: ['./reservation-search.component.css'],
    standalone: false
})
export class ReservationSearchComponent implements OnInit, OnChanges {

	@Input() showDialog = false;
	@Output() reservation = new EventEmitter<Reservation>();

	constructor(
		private authenticationService: AuthenticationService,
		private reviewService: ReviewService,
		private dataCacheService: DataCacheService,
		private alertService: AlertService,
		private messageService: MessageService,
		private router: Router,
		public dialogService: DialogService
	) { }

	ngOnInit(): void {
	}

	ngOnChanges(): void {
		if (this.showDialog) {
			this.onRowSelect()
		}
	}

	onRowSelect() {

		const ref = this.dialogService.open(ReservationSearchFormComponent, {
			data: {
				review: 1
			},	
			width: '80%',
			closeOnEscape: true
		});

		ref.onClose.subscribe((reservation: Reservation) => {
			if (reservation) {
				this.reservation.emit(reservation);
			}
		});
	}
}
